export default __webpack_public_path__ + "static/media/2195.a617f689.png";